import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { fonts } from "../../../styles/variables";
import iconArrowDown from "../../../assets/images/icons/arrow-down.svg";
import iconArrowUp from "../../../assets/images/icons/arrow-up.svg";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  cursor: pointer;
`;

export const FilterSectionTitle = styled.h5`
  margin-bottom: 0px !important;
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 20px;
  line-height: 1em;
`;

const ImageContainer = styled.img`
  height: 15px;
  width: 15px;
`;

const FiltersSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex: 1;
  padding-top: 20px;
  padding-bottom: ${(props) => (props.isOpen ? "0px" : "20px")};
`;

const FilterOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledButtonWithUpAndDownArrows = ({ isOpen = false, title, onClick, children }) => (
  <Container>
    <FiltersSectionContainer onClick={() => onClick()} isOpen={isOpen}>
      <FilterSectionTitle>{title}</FilterSectionTitle>
      <ImageContainer src={isOpen ? iconArrowUp : iconArrowDown} />
    </FiltersSectionContainer>
    <FilterOptionsContainer>{children}</FilterOptionsContainer>
  </Container>
);

StyledButtonWithUpAndDownArrows.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default StyledButtonWithUpAndDownArrows;
